import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonService } from 'app/services/common.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import {
  Component,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from './../../app.config';
import { IAppConfig } from './../../app.config.shared';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import { DraggableModal } from '../shared/draggable-modal/draggable-modal.class';
import { ConfirmModalService } from '../shared/confirm-modal/confirm-modal.service';


@Component({
  selector: 'app-message-grid',
  templateUrl: './message-grid.component.html',
  styleUrls: ['./message-grid.component.scss']
})
export class MessageGridComponent implements OnInit, OnDestroy {

  @Input() currentStudentProfileId: any;
  @Input() parentStatus: any;
  @Output() composeBoxShow: EventEmitter<any> = new EventEmitter();
  @HostBinding('style.width') width: Number;
  @HostBinding('style.height') height: Number;
  @HostBinding('style.float') float: String;

  studentUserId: number;
  isMessageSent: boolean;
  isDone: boolean;
  count: number;
  studentProfileId;
  messageLoader;
  currentPage = 1; // variable to store current page
  totalItems = 0; // variable to store total items
  maxSize = 50; // variable to store max size
  pageShow = false; // variable to check if pagination to be shown or not
  messages = [];
  inboxTotalItems = 0;
  sentCount = 0;
  doneCount = 0;
  showSort = [];
  userProfileId: string;
  getMessageResponseCopy = [];
  topic: any;
  subscribeInst: any;
  countedHead = [];
  messageData: any;
  studentData: any;
  isEdit: boolean;
  hidden: boolean;
  topicList = [];
  isParent: any;
  showCompose: any;
  roleName: any;
  getMessagesApiUrl: string;
  currentMessagePartnerId: number;
  assignmentTypeList = [];
  queueData = [];
  defaultArray = [];
  pageUrl = '';
  coachesData: any;
  toUserId: any;
  assignmentSubtypeHeader: any;
  assignmentSubtypeList: any;
  showSortAssignmentMgr = [false];
  assignToCoachJson = {};
  currentAssignmentMgrMessaageData: any;
  refreshInterval: any;
  index = 0;
  role: string;
  loginUserId: number;
  loginUserRole: string;
  loginUserModule: string;
  columnList = [];
  expandedItem: any;
  columnName: string;
  sendFlag: boolean;
  modalOpenedSubscription: Subscription;
  imageUrl: string;
  parentId: number;
  currentRoute: string;
  subs: Subscription[] = [];
  loader = false;
  fromMessage: string;
  selectedStudentCount = 0;
  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    @Inject(APP_CONFIG) private config: IAppConfig,
    private _commonService: CommonService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private commonDataSharedService: CommonDataSharedService,
    private _router: Router,
    private _routes: ActivatedRoute,
    private draggableModalService: DraggableModalService,
    private confirmModalService: ConfirmModalService
  ) {
  }

  ngOnInit() {
    this.commonDataSharedService.updateMessageCount.next();
    const currentRoute = this._router.url.split('/')[2].toString();
    if (currentRoute === 'assignmentMgr' || currentRoute === 'assignment') {
      this.sendFlag = true;
    }
    const localStorageData = JSON.parse(localStorage.getItem('loginUserData'));
    this.loginUserId = localStorageData.userId;
    this.loginUserRole = localStorageData.role;
    this.loginUserModule = localStorageData.module;
    this.pageUrl = window.location.href.split('/')[5];
    if (this.pageUrl === 'assignmentMgr' || this.pageUrl === 'assignment') {
      this.fromMessage = 'Assignment';
    }
    else {
      this.fromMessage = 'CommCenter';
    }
    this.defaultArray.push('partnerId');
    this.subs.push(
      this.commonDataSharedService.countUpdate.subscribe((data) => {
        this.getCountValue(data);
        this.getStudentCountValue();
      })
    )

    this.subscribeInst = this.commonDataSharedService.gridReRender.subscribe((data: any) => {
      if (data) {
        if (data.from === 'Parent Child Messages') {
          this.currentStudentProfileId = data.currentStudentProfileId;
          this.setUserData();
        }
        if (data.renderStatus) {
          this.reRenderGrid();
        }
      }

    });

    this.role = this._commonAuthService.getRoleName();
    this.getAssignmentType();
    this.getQueueData();
    this.setComposeButtonShowStatus();
    this.reRenderGrid();

    this.refreshInterval = setInterval(() => {
      if (!this.isMessageSent && !this.isDone) {
        this.getMessageList('inbox', false);
        this.commonDataSharedService.updateMessageCount.next();
      }
    }, 60 * 1000);

    // reRender
    this.modalOpenedSubscription = this.draggableModalService.modalOpened.subscribe((modal: DraggableModal) => {
      if (modal.id.indexOf('modal-assign-to-coach') > -1) {
        const reRenderSubscription = modal.modalRef.content.reRender.subscribe(() => {
          this.reRenderGrid();
          this.getMessageList('inbox', true);
          reRenderSubscription.unsubscribe();
        });
      }
    });
  }

  ngOnDestroy() {
    clearInterval(this.refreshInterval);
    this.subscribeInst.unsubscribe();
    this.subs.forEach(sub => sub.unsubscribe());
    localStorage.removeItem('sortData');
  }

  getAssignmentType() {
    const selectedType = {
      classTypeName: 'Assignment Subtype',
    };

    let serviceUrl;
    const defaultArray = [];
    defaultArray.push('partnerId');

    if (this.currentMessagePartnerId) {
      selectedType['partnerId'] = this.currentMessagePartnerId;
      serviceUrl = this._commonRequestResponseService.postWithHeader('admin/values/', selectedType, defaultArray);
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader('admin/values/', selectedType);
    }
    serviceUrl.subscribe(
      (data: any) => {
        this.assignmentTypeList = [];
        this.assignmentTypeList = this._commonService.findUnique(data.items);
        if (this.pageUrl === 'assignmentMgr') {
          this.assignmentSubtypeHeader = JSON.parse(JSON.stringify(data.items));
          this.assignmentSubtypeList = data.items;
        }
      },
      () => {
        this.notificationService.show('error', 'Error while fetching assignment type data');
      });
  }

  getQueueData() {
    const selectedType = {
      classTypeName: 'Assignment Types',
    };

    let serviceUrl;
    const defaultArray = [];
    defaultArray.push('partnerId');
    selectedType['partnerId'] = this.currentMessagePartnerId;

    if (this.currentMessagePartnerId) {
      serviceUrl = this._commonRequestResponseService.postWithHeader('admin/values/', selectedType, defaultArray);
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader('admin/values/', selectedType);
    }
    serviceUrl.subscribe(
      (data: any) => {
        this.queueData = [];
        this.queueData = this._commonService.findUnique(data.items);
      },
      () => {
        this.notificationService.show('error', 'Error while fetching assignment type data');
      });
  }

  setComposeButtonShowStatus() {

    if (!this.roleName) {
      this.roleName = this._commonAuthService.getModule().toLowerCase();

      // Need refactoring
      switch (this.roleName) {
        case 'coach':
          if (this.pageUrl === 'comMessages') {
            this.getMessagesApiUrl = 'coach/communicationcenter';
          }
          if (this.pageUrl === 'studentSummary') {
            this.getMessagesApiUrl = 'shared/messages';
          }
          if (this.pageUrl === 'assignment') {
            this.getMessagesApiUrl = 'coach/assignments';
          }
          if (this.pageUrl === 'essays') {
            this.getMessagesApiUrl = 'coach/essays';
          }
          if (this.pageUrl === 'assignmentMgr') {
            this.getMessagesApiUrl = 'coach/assignmentmanager';
          }
          if (this.pageUrl === 'coachStudentDetail') {
            this.getMessagesApiUrl = 'shared/Coachmessages';
            this.setUserData();
            this.setParentStatus();
          }
          break;

        default:
          this.setUserData();
          this.setParentStatus();
          this.getMessagesApiUrl = 'shared/messages';
          break;
      }
      this.showCompose = this.roleName && this.roleName === 'parent' && this.parentStatus || this.roleName && this.roleName === 'student' || this.pageUrl === 'coachStudentDetail' || this.parentStatus && this.pageUrl === 'studentSummary';
    }
  }

  setUserData() {
    if (this.currentStudentProfileId) {
      this.userProfileId = this.currentStudentProfileId;
    } else {
      this.userProfileId = this._commonAuthService.getProfileId();
    }
  }

  setParentStatus() {
    this.isParent = this.parentStatus;
    if (this.isParent) {
      this.roleName = 'parent';
    }
  }

  getDoneData(item) {
    this.loader = true;
    this.setActiveClass(item);
    this.setColumnList(this.roleName, 'done');
    this.toggleMessageLoader(true);
    const inputJson = {
      page: this.currentPage,
      pageSize: this.maxSize,
      userId: this.getRecipientUserId(),
      From: this.fromMessage
    };

    if (this.pageUrl === 'assignmentMgr') {
      inputJson['From'] = 'Assignment Manager';
    }

    this._commonRequestResponseService.postWithHeader('coach/messages/done', inputJson)
      .subscribe(
        (data: any) => {
          this.loader = false;
          this.doneCount = data.totalItems;
          this.toggleMessageLoader(false);
          if (item === 'done') {
            this.messages = data.itemList;
            this.topicList = data.subjectList;
            this.messages.forEach((message: any) => {
              this._commonService.formatDate(message);
            });
            // this.messages.sort(this._commonService.dynamicSort('-messageDate', false));
            this.getMessageResponseCopy = data.itemList;
            this.totalItems = data.totalItems;
          }
        },
        () => {
          this.loader = false;
          this.toggleMessageLoader(false);
          this.notificationService.show('error', 'Error while getting messages list');
        });
  }

  getRecipientUserId() {
    const parentId = +localStorage.getItem('selectedStudentParentId');
    return (this.pageUrl === 'coachStudentDetail') ? localStorage.getItem('studentLocalId') : (this.pageUrl === 'studentSummary') && (!this.parentStatus) ? localStorage.getItem('parentStudentId') : (this.pageUrl === 'studentSummary') && (this.parentStatus) && (this.loginUserRole !== 'Parent') ? parentId : this.loginUserId;
  }

  getMessageList(item, loaderStatus) {
    let inputJson;
    this.setActiveClass(item);
    this.setColumnList(this.roleName, '');
    const sortableData = JSON.parse(localStorage.getItem('sortData'));
    inputJson = {
      page: this.currentPage,
      pageSize: this.maxSize,
      userProfileId: this.userProfileId,
      isParent: this.isParent,
      userId: this.getRecipientUserId(),
      sortby: sortableData ? sortableData : ''
    };
    this.loader = (this._router.url !== '/coach/coachStudentDetail' && loaderStatus) ? true : false;
    this._commonRequestResponseService.postWithHeader(this.getMessagesApiUrl, inputJson)
      .subscribe(
        (response: any) => {
          this.loader = false;
          this.toggleMessageLoader(false);
          if (this.isMessageSent || this.isDone) {
            return;
          }
          this.messages = response.itemList || [];
          this.getMessageResponseCopy = response.itemList || [];
          this.totalItems = response.totalItems;
          this.inboxTotalItems = response.totalItems;
          this.pageShow = true;
          this.topicList = response.subjectList || [];
          this.messages.forEach((message: any) => {
            this._commonService.formatDate(message);
            if (this.expandedItem && message.messageId === this.expandedItem.messageId) {
              message.opened = true;
              message.showFull = true;
            }
          });
          if (sortableData) {
            this.sortTable(sortableData[0], sortableData[1], sortableData[2])
          }
          // this.messages.sort(this._commonService.dynamicSort('-messageDate', false));
        },
        () => {
          this.toggleMessageLoader(false);
          this.loader = false;
          this.notificationService.show('error', 'Error while getting messages list');
        });
  }

  getMessageSentData(item) {
    this.setActiveClass(item);
    this.toggleMessageLoader(true);
    let type = 'CommCenter';
    switch (this.pageUrl) {
      case 'assignment':
        type = 'Assignment';
        break;
      case 'assignmentMgr':
        type = 'Assignment';
        break;
      case 'essays':
        type = 'Essays';
        break;
      default:
        type = 'CommCenter';
        break;
    }

    const inputJson = {
      page: this.currentPage,
      pageSize: this.maxSize,
      type: type,
      role: this.pageUrl === 'coachStudentDetail' ? 'student' : (this.pageUrl === 'studentSummary') && (!this.parentStatus) ? 'student' : (this.pageUrl === 'studentSummary') && (this.parentStatus) ? 'parent' : this.roleName,
      isParent: this.isParent,
      userId: this.getRecipientUserId()
    };
    this.loader = true;
    this._commonRequestResponseService.postWithHeader('coach/sentassignments', inputJson)
      .subscribe(
        (data: any) => {
          this.loader = false;
          this.sentCount = data.totalItems;
          this.imageUrl = data.avatarURL;
          if (item === 'sent') {
            const messageIds = data.items.map(messageIdData => messageIdData.messageId);
            this.messages = data.items;
            this.getMessageResponseCopy = data.items;
            this.totalItems = data.totalItems;
            this.topicList = data.items.map(message => message.subject);
            this.messages.forEach((message: any) => {
              this._commonService.formatDate(message);
            });
            // this.messages.sort(this._commonService.dynamicSort('-messageDate', false));
            this.columnList.forEach((column: any) => {
              if (column.key === 'lock') {
                this.columnList = [

                  { label: 'From', key: 'fromName', type: 'fromName', width: '14.5%', widthhead: '14.5%' },
                  { label: 'Subject', key: 'subject', type: 'subject', width: '22.5%', widthhead: '22%' },
                  { label: 'File', key: 'isAttachment', type: 'file', width: '10%', widthhead: '9%' },
                  { label: 'Partner', key: 'company', type: 'string', width: '10%', widthhead: '10%' },

                  { label: 'Received', key: 'dateFormatted', type: 'date', width: '10%', widthhead: '10%' },
                  { label: 'Sent', key: 'dateCompletedFormatted', type: 'date', width: '12%', widthhead: '10%' },
                  { label: 'Editor Name', key: 'receipient', type: 'string', width: '20%', widthhead: '20%' },
                ];
                this.showSort = [false, false, false, false, false, false];
              }
            });
          }

          this.toggleMessageLoader(false);
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  setColumnList(roleName, data) {

    switch (roleName) {
      case 'student':
        this.columnList = [
          { label: 'From', key: 'fromName', type: 'fromName', width: '15.5%', widthhead: '15%' },
          { label: 'Subject', key: 'subject', type: 'subject', width: '45.5%', widthhead: '45%' },
          { label: 'Date', key: 'dateFormatted', type: 'date', width: '15%', widthhead: '15%' },
          { label: 'File', key: 'isAttachment', type: 'file', width: '15%', widthhead: '25%' }
        ];
        this.showSort = [false, false, false, false];
        break;
      case 'coach':
        if (this.pageUrl === 'comMessages') {
          this.columnList = [
            { label: 'Date', key: 'dateFormatted', type: 'date', width: '15%', widthhead: '15%' },
            { label: 'From', key: 'firstlast', type: 'firstlast', width: '14.5%', widthhead: '14%' },
            { label: 'Partner', key: 'company', type: 'string', width: '10%', widthhead: '10%' },
            { label: 'Subject', key: 'subject', type: 'subject', width: '21%', widthhead: '20%' },
            { label: 'File', key: 'isAttachment', type: 'file', width: '10%', widthhead: '10%' },
            { label: 'Client Number', key: 'clientID', type: 'string', width: '15%', widthhead: '15%' },
            { label: 'Status', key: 'lock', type: 'icon', width: '9%', widthhead: '16%' },

          ];
          this.showSort = [false, false, false, false, false, false, false];
        }
        if (this.pageUrl === 'assignment') {
          this.columnList = [
            { label: 'From', key: 'fromName', type: 'fromName', width: '14.5%', widthhead: '14.5%' },
            { label: 'Subject', key: 'subject', type: 'subject', width: '24.5%', widthhead: '24%' },
            { label: 'File', key: 'isAttachment', type: 'file', width: '10%', widthhead: '10%' },
            { label: 'Partner', key: 'company', type: 'string', width: '15%', widthhead: '15.5%' },
            { label: 'Date/Time', key: 'dateFormatted', type: 'date', width: '15%', widthhead: '15%' },
            { label: 'Type', key: 'type', type: 'string', width: '20%', widthhead: '20%' },

          ];

          this.showSort = [false, false, false, false, false, false];
        }
        if (data === 'done' && this.pageUrl === 'assignment') {
          this.columnList = [
            { label: 'From', key: 'fromName', type: 'fromName', width: '16%', widthhead: '14.5%' },
            { label: 'Subject', key: 'subject', type: 'subject', width: '25%', widthhead: '24%' },
            { label: 'File', key: 'isAttachment', type: 'file', width: '11%', widthhead: '10%' },
            { label: 'Partner', key: 'company', type: 'string', width: '16%', widthhead: '15.5%' },
            { label: 'Received', key: 'dateFormatted', type: 'date', width: '10%', widthhead: '10%' },
            { label: 'Sent', key: 'dateCompletedFormatted', type: 'date', width: '12%', widthhead: '10%' },
            { label: 'Type', key: 'type', type: 'string', width: '10%', widthhead: '10%' },

          ];

          this.showSort = [false, false, false, false, false, false];
        }
        if (this.pageUrl === 'essays') {
          this.columnList = [
            { label: 'From', key: 'fromName', type: 'fromName', width: '22%', widthhead: '21%' },
            { label: 'Subject', key: 'subject', type: 'subject', width: '16.5%', widthhead: '16%' },
            { label: 'File', key: 'isAttachment', type: 'file', width: '12%', widthhead: '12%' },
            { label: 'Partner', key: 'company', type: 'string', width: '12%', widthhead: '12%' },
            { label: 'Date Time', key: 'dateFormatted', type: 'date', width: '17%', widthhead: '17%' },
            { label: 'Status', key: 'lock', type: 'icon', width: '11%', widthhead: '22%' },
          ];
          this.showSort = [false, false, false, false, false, false];
        }
        if (this.pageUrl === 'assignmentMgr') {
          this.columnList = [
            { label: 'From', key: 'firstName', type: 'firstName', width: '15%', widthhead: '18%' },
            { label: 'Subject', key: 'subject', type: 'subject', width: '16.5%', widthhead: '14%' },
            { label: 'File', key: 'isAttachment', type: 'file', width: '10%', widthhead: '10%' },
            { label: 'Partner', key: 'company', type: 'string', width: '12%', widthhead: '12%' },
            { label: 'Client', key: 'clientID', type: 'string', width: '12%', widthhead: '12%' },
            { label: 'Date', key: 'dateFormatted', type: 'date', width: '13%', widthhead: '15%' },
            { label: 'Type', key: 'assignmentType', type: 'string', width: '10%', widthhead: '11%' },
            { label: 'Status', key: 'lock', type: 'icon', width: '9%', widthhead: '12%' },
          ];
          this.showSort = [false, false, false, false, false, false];

        }
        if (data === 'done' && this.pageUrl === 'assignmentMgr') {
          this.columnList = [
            { label: 'From', key: 'firstName', type: 'firstName', width: '14%', widthhead: '14.5%' },
            { label: 'Subject', key: 'subject', type: 'subject', width: '20%', widthhead: '15%' },
            { label: 'File', key: 'isAttachment', type: 'file', width: '10%', widthhead: '10%' },
            { label: 'Partner', key: 'company', type: 'string', width: '10%', widthhead: '10.5%' },
            { label: 'Client', key: 'clientID', type: 'string', width: '12%', widthhead: '10%' },
            { label: 'Received', key: 'dateFormatted', type: 'date', width: '10%', widthhead: '10%' },
            { label: 'Sent', key: 'dateCompletedFormatted', type: 'date', width: '12%', widthhead: '10%' },
            { label: 'Type', key: 'type', type: 'string', width: '10%', widthhead: '10%' },

          ];

          this.showSort = [false, false, false, false, false, false];
        }
        if (this.pageUrl === 'coachStudentDetail') {
          this.columnList = [
            { label: 'Date', key: 'dateFormatted', type: 'date', width: '20%', widthhead: '20%' },
            { label: 'From', key: 'firstlast', type: 'firstlast', width: '29.8%', widthhead: '29%' },
            { label: 'Subject', key: 'subject', type: 'subject', width: '34%', widthhead: '34%' },
            { label: 'File', key: 'isAttachment', type: 'file', width: '15%', widthhead: '17%' }
          ];
          this.showSort = [false, false, false, false];
        }
        break;
      case 'parent':
        this.columnList = [
          { label: 'Date', key: 'dateFormatted', type: 'date', width: '20%', widthhead: '20%' },
          { label: 'From', key: 'fromName', type: 'fromName', width: '30%', widthhead: '29%' },
          { label: 'Subject', key: 'subject', type: 'subject', width: '35%', widthhead: '34%' },
          { label: 'File', key: 'isAttachment', type: 'file', width: '15%', widthhead: '17%' }
        ];
        this.showSort = [false, false, false, false];
        break;
    }
  }

  setActiveClass(item) {
    switch (item) {
      case 'inbox':
        this.isMessageSent = false;
        this.isDone = false;
        break;
      case 'sent':
        this.isMessageSent = true;
        this.isDone = false;
        break;
      case 'done':
        this.isDone = true;
        this.isMessageSent = false;
        break;
    }
  }

  toggleMessageLoader(messageLoaderStatus) {
    this.messageLoader = messageLoaderStatus;
  }

  showSelectedMessage(item) {
    const loginData = JSON.parse(localStorage.getItem('loginUserData'))
    if (!this.parentStatus && loginData.role === 'Parent') {
      this.expandedItem = item;
      item.showFull = !item.showFull;
    } else {
      this.expandedItem = item;
      item.showFull = !item.showFull;
      if (item.showFull) {
        if (!item.read) {
          const inputJson = { id: (item.messageID ? item.messageID : item.messageId) };
          this._commonRequestResponseService.postWithHeader('shared/readmessage', inputJson)
            .subscribe(() => {
              this.notificationService.show('success', 'Message read successfully');
              item.read = true;
              if (loginData.role === 'Student' || loginData.role === 'Parent') {
                this.commonDataSharedService.updateMessageCount.next();
              }

            },
              () => {
                this.notificationService.show('error', 'Error while reading message');
              });
        }
      } else {
        this.expandedItem = {};
      }
    }

  }

  pageChanged() {
    if (this.isMessageSent) {
      this.getMessageSentData('sent');
    } else if (this.isDone) {
      this.getDoneData('done');
    } else {
      this.getMessageList('inbox', true);
    }
  };

  /**
   *@ngdoc method
   *@name setPage
   *@methodOf security.component
   *@description
   * - This is a method, which is used to set current page
   */
  setPage(pageNo: number) {
    this.currentPage = pageNo;
  };

  sortTable(orderBy, columnName, order) {
    this.columnName = orderBy === 'desc' ? '-' + columnName : columnName;
    localStorage.setItem('sortData', JSON.stringify([orderBy, columnName, order]));
    this.showSort[order] = !this.showSort[order];
    if (columnName === 'dateFormatted') {
      this.messages.sort(this._commonService.dynamicDateMessageSort(this.columnName, false));

    }
    else {
      this.messages.sort(this._commonService.dynamicSort(this.columnName, false));

    }
  }

  reRenderGrid() {
    if (this.isMessageSent) {
      this.getMessageSentData('');
      return;
    }
    if (this.isDone) {
      this.getDoneData('done');
      return;
    }
    this.getMessageList('inbox', true);
  }

  searchBySubject() {
    const resultArray = this._commonService.searchInSeveralFields(this.getMessageResponseCopy, ['clientID', 'name', 'subject', 'fromName', 'receipient', 'company'], this.topic);

    if (this.topic && resultArray.length >= 0) {
      this.messages = resultArray;
      this.totalItems = resultArray.length;
    } else {
      this.messages = this.getMessageResponseCopy;
      this.totalItems = this.getMessageResponseCopy.length;
    }
  }

  messageReply(item, type, itemObj) {
    this.toUserId = item.fromUserId ? item.fromUserId : '-1';
    localStorage.setItem('forStudentId', this.toUserId);
    this.messageData = item;
    this.isEdit = true;
    this.hidden = false;
    const currentUrl = window.location.href.split('/');
    this.messageData.queueData = this.queueData;
    this.messageData.messageFromScreen = currentUrl;
    this.messageData.messageAssignmentType = type;
    this.messageData.messageAssignmentSubType = itemObj;
    const resetJson = {
      hidden: this.hidden,
      isEdit: this.isEdit,
      messageData: this.messageData
    };

    if (type === 'essay') {
      const inputJson = {
        toUserIds: this.messageData.fromUserId,
        messageId: this.messageData.messageId,
        subject: this.messageData.subject,
        partnerId: this.messageData.partnerId,
        studentId: this.messageData.toUser
      };

      localStorage.setItem('essayData', JSON.stringify(inputJson))
    } else if (type === 'assignment') {

      const inputJson = {
        toUserIds: this.messageData.fromUserId,
        messageId: this.messageData.messageId,
        subject: this.messageData.subject,
        assignmentSubType: this.messageData.messageAssignmentSubType.value,
        partnerId: this.messageData.partnerId,
        studentId: this.messageData.toUser

      };

      localStorage.setItem('assignmentData', JSON.stringify(inputJson))
    }

    this.composeBoxShow.emit(resetJson);
  }

  showNewMessage() {
    this.isEdit = false;
    this.hidden = false;
    const currentUrl = window.location.href.split('/');
    this.messageData = {};
    this.messageData.queueData = [];
    this.messageData.messageFromScreen = currentUrl;
    this.messageData.messageAssignmentType = 0;
    this.messageData.messageAssignmentSubType = 0;
    const resetJson = { hidden: this.hidden, isEdit: this.isEdit, messageData: this.messageData };
    this.composeBoxShow.emit(resetJson);
  }

  copyCommMessage(item) {
    this.loader = true;
    let serviceUrl;

    const inputJson = {
      messageId: item.messageId
    };

    if (this.getCurrentMessagePartnerId(item)) {
      inputJson['partnerId'] = this.getCurrentMessagePartnerId(item);
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/communicationcenter/copy', inputJson, this.defaultArray);
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/communicationcenter/copy', inputJson);
    }

    serviceUrl
      .subscribe(
        () => {
          this.loader = false;
          this.notificationService.show('success', 'Message copy successfully');
          this.reRenderGrid();
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while fetching data');
        });
  }


  movefromDone(item: any, type: string, itemObj: any) {
    this.loader = true;
    let serviceUrl;
    const inputJson = {
      messageId: item.messageId,
      undoDismiss: 1
    };
    if (this.getCurrentMessagePartnerId(item)) {
      inputJson['partnerId'] = this.getCurrentMessagePartnerId(item);
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/dismissmessage', inputJson, this.defaultArray);
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/dismissmessage', inputJson);
    }
    serviceUrl.subscribe(
      () => {
        this.loader = false;
        this.notificationService.show('success', 'Message move successfully');
        this.commonDataSharedService.updateMessageCount.next();
        this.reRenderGrid();
      },
      (error) => {
        this.loader = false;
        console.error(error);
        this.notificationService.show('error', 'Error while fetching data');
      }
    );
  }


  moveCommMessage(item, type, itemObj) {
    this.loader = true;
    let queueClassId;
    let assignmentType;
    let serviceUrl;

    if (type === 'essay') {
      queueClassId = this.getQueueType(type);
      assignmentType = 0;
    } else {
      queueClassId = this.getQueueType(type);
      assignmentType = itemObj.value;
    }

    const inputJson = {
      messageId: item.messageId,
      queueClassId: queueClassId,
      assignmentClassId: assignmentType
    };

    if (this.getCurrentMessagePartnerId(item)) {
      inputJson['partnerId'] = this.getCurrentMessagePartnerId(item);
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/communicationcenter/move', inputJson, this.defaultArray);
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/communicationcenter/move', inputJson);
    }
    serviceUrl.subscribe(
      () => {
        this.loader = false;
        this.notificationService.show('success', 'Message move successfully');
        this.commonDataSharedService.updateMessageCount.next();
        this.reRenderGrid();
      },
      () => {
        this.loader = false;
        this.notificationService.show('error', 'Error while fetching data');
      }
    );
  }

  dismissCommMessage(item) {
    this.loader = true;
    const inputJson = {
      messageId: item.messageId
    };
    this._commonRequestResponseService.postWithHeader('coach/dismissmessage', inputJson)
      .subscribe(
        () => {
          this.loader = false;
          this.notificationService.show('success', 'Message removed successfully');
          this.commonDataSharedService.updateMessageCount.next();
          this.reRenderGrid();
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while dismiss message');
        });
  }

  messageReplyConfirmation(item: any, type, itemObj) {

    this.confirmModalService.open({
      ok: () => {
        this.messageReply(item, type, itemObj)
      },
      text: `<p>Please confirm you want to reply <b>without</b> adding to Essay or Assignment queues.</p>`,
      labels: ['Reply', 'Cancel'],
    });
  }

  moveMessageConfirmation(item: any, type, itemObj) {

    this.confirmModalService.open({
      ok: () => {
        this.moveCommMessage(item, type, itemObj)
      },
      text: type === 'essay' ? `<p class="move-without-reply-modal">Please confirm you want to <b>move</b> to Essay queue <b>without</b> replying.</p>` : `<p>Please confirm you want to <b>move</b> to Assignment queue <b>without</b> replying.  <p class="assign-type-modal">Assignment - ${itemObj.text}</p></p>`,
      labels: ['Move', 'Cancel']
    });
  }

  moveAssignMessageConfirmation(item: any) {

    this.confirmModalService.open({
      ok: () => {
        this.moveFromEssayToMessage(item)
      },
      text: `<p class="move-without-reply-modal">Please confirm you want to <b>move</b> this message <b>without</b> replying.</p>`,
      labels: ['Move', 'Cancel']
    });
  }


  dismissMessageConfirmation(item: any) {
    this.confirmModalService.open({
      ok: () => {
        this.dismissCommMessage(item)
      },
      text: `<p class="dismiss-modal-text">Please confirm you want to <b>dismiss</b> this message.</p>`,
      labels: ['Dismiss', 'Cancel']
    });
  }


  dismissEssays(item) {
    this.loader = true;
    const inputJson = {
      messageId: item.messageId
    };
    this._commonRequestResponseService.postWithHeader('coach/dismissessays', inputJson)
      .subscribe(
        () => {
          this.loader = false;
          this.notificationService.show('success', 'Essay removed successfully');
          this.reRenderGrid();
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while dismiss essay');
        });
  }

  lockUnLockCommMessage(item, check) {
    if (!check) {
      let inputJson;
      let serviceUrl;

      if (this.pageUrl === 'assignmentMgr') {
        inputJson = {
          id: item.messageId,
          Lock: !item.lock
        };

        if (this.getCurrentMessagePartnerId(item)) {
          inputJson.partnerId = this.getCurrentMessagePartnerId(item);
          serviceUrl = this._commonRequestResponseService.putWithHeader('shared/lockUnlockAssignment', inputJson, this.defaultArray);
        } else {
          serviceUrl = this._commonRequestResponseService.putWithHeader('shared/lockUnlockAssignment', inputJson);
        }
      }

      else if (this.pageUrl === 'essays') {
        inputJson = {
          Messageid: item.messageId,
          Lock: !item.lock
        };

        if (this.getCurrentMessagePartnerId(item)) {
          inputJson.partnerId = this.getCurrentMessagePartnerId(item);
          serviceUrl = this._commonRequestResponseService.putWithHeader('shared/lockUnlockEssay', inputJson, this.defaultArray);
        } else {
          serviceUrl = this._commonRequestResponseService.putWithHeader('shared/lockUnlockEssay', inputJson);
        }
      } else {

        inputJson = {
          Messageid: item.messageId,
          Lock: !item.lock
        };

        if (this.getCurrentMessagePartnerId(item)) {
          inputJson.partnerId = this.getCurrentMessagePartnerId(item);
          serviceUrl = this._commonRequestResponseService.putWithHeader('shared/lockUnlockMessage', inputJson, this.defaultArray);
        } else {
          serviceUrl = this._commonRequestResponseService.putWithHeader('shared/lockUnlockMessage', inputJson);
        }
      }

      serviceUrl.subscribe(
        () => {

          if (!inputJson.Lock) {
            this.notificationService.show('success', 'Message unlock successfully');
          } else {
            this.notificationService.show('success', 'Message lock successfully');
          }

          this.reRenderGrid();
        },
        (error) => {
          this.notificationService.show('error', 'Error While trying to Lock a message.');
        }
      );
    }
    else {
      this.notificationService.show('error', `You don't have access to Unlock`);
    }
  }

  moveToAssignment(item) {
    this.loader = true;
    const inputJson = {
      messageId: item.messageId,
      assignmentSubType: 0,
      MoveToMessage: 'false',
      MovetoAssigmentManager: 'true'
    };

    let serviceUrl;

    if (this.getCurrentMessagePartnerId(item)) {
      inputJson['partnerId'] = this.getCurrentMessagePartnerId(item);
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/assignmentupdate', inputJson, this.defaultArray);
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/assignmentupdate', inputJson);
    }

    serviceUrl
      .subscribe(
        () => {
          this.loader = false;
          this.notificationService.show('success', 'Assignment move successfully');
          this.reRenderGrid();
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while move assignment');
        });
  }

  updateToAssignment(item, assignSubTypeObj) {
    this.loader = true;
    const inputJson = {
      messageId: item.messageId,
      assignmentSubType: assignSubTypeObj.value,
      Move: 'false'
    };

    let serviceUrl;

    if (this.getCurrentMessagePartnerId(item)) {
      inputJson['partnerId'] = this.getCurrentMessagePartnerId(item);
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/assignmentupdate', inputJson, this.defaultArray);
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/assignmentupdate', inputJson)
    }

    serviceUrl
      .subscribe(
        () => {
          this.loader = false;
          this.notificationService.show('success', 'Assignment update successfully');
          this.reRenderGrid();
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while update assignment');
        });
  }

  moveFromEssayToMessage(item) {
    this.loader = true;
    const inputJson = {
      messageId: item.messageId
    };

    let serviceUrl;

    if (this.getCurrentMessagePartnerId(item)) {
      inputJson['partnerId'] = this.getCurrentMessagePartnerId(item);
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/essay/move', inputJson, this.defaultArray);
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/essay/move', inputJson)
    }

    serviceUrl
      .subscribe(
        () => {
          this.loader = false;
          this.notificationService.show('success', 'Item moved to messages successfully');
          this.reRenderGrid();
          this.commonDataSharedService.updateMessageCount.next();
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while move message');
        });
  }

  getCoachesData(item) {
    this.loader = true;
    let serviceUrl;
    const selectedType = {};
    if (this.getCurrentMessagePartnerId(item)) {
      selectedType['partnerId'] = this.getCurrentMessagePartnerId(item);
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/assignmentmanager/coaches', selectedType, this.defaultArray);
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader('coach/assignmentmanager/coaches', selectedType);
    }
    serviceUrl.subscribe(
      (data: any) => {
        this.loader = false;
        this.coachesData = data.items;
      },
      () => {
        this.loader = false;
        this.notificationService.show('error', 'Error while fetching data');
      });
  }

  setUpAssignToCoachData(item) {
    this.currentAssignmentMgrMessaageData = item;
    this.assignToCoachJson = {
      messageId: item.messageId
    }
  }

  getQueueType(type) {
    const result = this.queueData.map((data: any) => data.text.toLowerCase() === type ? data.value : '').filter(function (e) {
      return e !== ''
    });
    return result[0];
  }

  getCurrentMessagePartnerId(item) {
    if (item && item.partnerId) {
      return item.partnerId;
    }
  }

  getCountValue(data) {
    this.currentRoute = this._routes.snapshot.url[0].path;
    if (this.currentRoute === 'essays') {
      this.count = data.essaysCount;
    } else if (this.currentRoute === 'assignmentMgr') {
      this.count = data.assignmentManagerCount;
    } else if (this.currentRoute === 'comMessages' || this.currentRoute === 'messages' || this.currentRoute === 'studentSummary') {
      this.count = data.messagesCount;
    } else if (this.currentRoute === 'assignment') {
      this.count = data.assignmentCount;
    }
  }

  getStudentCountValue() {
    const inputJson = {
      userRoleData: this._commonAuthService.getRoleName(),
      userId: JSON.parse(localStorage.getItem('studentLocalId'))
    };
    this._commonRequestResponseService.post('shared/get/counts', inputJson)
      .subscribe(
        (countData: any) => {
          this.selectedStudentCount = countData.messagesCount;
        },
        (error) => {
          // this.notificationService.showSuccessErrorMessage('error', 'Error while calling service');
          /*console.error(error);*/
        }
      );
  }
  viewAccount(item) {
    this.studentData.firstName = item.firstName;
    this.studentData.lastName = item.lastName;
    this.studentData.partnerId = item.partnerId;
    this.studentData.profileId = item.fromUserProfileId;
    this.studentData.studentUserId = item.fromUserId;
    this._commonService.setDataWithoutObservable(this.studentData, 'recentStudentDetail');
    this._router.navigate(['../coachStudentDetail'], { relativeTo: this._routes });
  }

  openAssignmentManagerModal(event: MouseEvent, item: any) {
    this.setUpAssignToCoachData(item);
    const baseId = 'modal-assign-to-coach';
    const id = `${baseId}-${item.assignmentId}`;
    const header = `Assign '${item.subject}' to coach`;
    const existingHeaders = this.assignmentSubtypeHeader.map(h => h.text);
    const filteredTableHead = this.countedHead.filter(head => existingHeaders.includes(head.key));
    this.draggableModalService.show({
      id,
      baseId,
      trayTitle: header,
      width: 1170,
      initialState: {
        header,
        item,
        scoreboardAssignmentType: item.assignmentTypeClassID || '',
        partnerId: item.partnerId,
        showSort: this.showSort,
        getMessageResponse: this.messages,
        countedHead: filteredTableHead,
        assignmentSubtypeHeader: this.assignmentSubtypeHeader,
        showSortAssignmentMgr: this.showSortAssignmentMgr,
        assignmentSubtypeList: this.assignmentSubtypeList
      }
    });
  }
}
